// Scroll-triggered animations (migrated from Astro inline script)

document.addEventListener('DOMContentLoaded', function() {

  // Psychedelic scroll reveal for products
  var productCols = document.querySelectorAll('.product-col');
  var psycheObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('psyche-in');
      }
    });
  }, { threshold: 0.2 });
  productCols.forEach(function(col) { psycheObserver.observe(col); });

  // About section — splat animation
  var aboutSplat = document.querySelector('.about-splat');
  var aboutContent = document.getElementById('about-content');
  var aboutObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        aboutObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  var contentObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        contentObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  if (aboutSplat) aboutObserver.observe(aboutSplat);
  if (aboutContent) contentObserver.observe(aboutContent);

  // About bottom image reveal
  var aboutBottomWrap = document.querySelector('.about-bottom-wrap');
  if (aboutBottomWrap) {
    var bottomObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
          bottomObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });
    bottomObserver.observe(aboutBottomWrap);
  }

  // FAQ splash + drip animation
  var faqSplat = document.querySelector('.faq-splat');
  if (faqSplat) {
    var faqObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          faqObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    faqObserver.observe(faqSplat);
  }

  // Contact section animations
  var contactContent = document.getElementById('contact-content');
  if (contactContent) {
    var contactObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          contactObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    contactObserver.observe(contactContent);
  }

  // FAQ content animations
  var faqContent = document.getElementById('faq-content');
  if (faqContent) {
    var faqContentObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          faqContentObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    faqContentObserver.observe(faqContent);
  }

});
